module.exports = __webpack_public_path__ + "static/media/location-weed.20fa9c79.png";